import * as Api from '@/api';
import tableHeaderName from '@/utils/table_header_name';
import { _restApiDataFormatting, checkFileFormat } from '@/utils/_function.js';
import { API_ORIGIN } from '@/api/path';

export default {
  name: 'PowerOfAttorneyDetail',
  data() {
    return {
      proxyDetail: null,
      fileFormat: 'png',
      historyFields: tableHeaderName.historyFields
    };
  },
  watch: {
    proxyDetail() {
      if (this.proxyDetail && this.proxyDetail.fileUrl) {
        this.fileFormat = checkFileFormat(this.proxyDetail.fileUrl);
      }
    }
  },
  mounted() {
    this.getPowerOfAttorneyDetailData();
  },
  computed: {
    getPowerOfAttorneyDetailLoaderStatus() {
      return this.$store.getters.LOADERS.includes('powerOfAttorney');
    }
  },
  methods: {
    getPowerOfAttorneyDetailData() {
      const proxyId = this.$route.params.id;
      const blocker = 'powerOfAttorney';

      Api.getPowerOfAttorneyDetailData(proxyId, blocker)
        .then((response) => {
          if (response) {
            this.proxyDetail = _restApiDataFormatting(response);
          }
        })
        .catch((error) => {
          if (error) {
            this.$rollbar.warning(error);
          }
          this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
        });
    },
    editProxy() {
      this.$router.push({ path: `/proxy-edit/${this.proxyDetail.id}` });
    },

    downloadUrl(url) {
      let q = new URL(url);
      if ((process.env.NODE_ENV === 'development') || (process.env.NODE_ENV === 'production')) {
        q.host = new URL(API_ORIGIN).host;
        q.pathname = 'api/v1/file_proxy' + q.pathname;
      }
      return q.href;
    }
  }
};
